import { router } from "@/router";

export const redirectToLogin = () => {
  router.navigate({
    to: "/login",
  });
};
